import Vue from 'vue'
import Vuex from 'vuex'
import profile from './modules/profile'
import entity from './modules/entity'
import checklist from './modules/checklist'
import bankaccount from './modules/bankaccount'
import cashbook from './modules/cashbook'
import transaction from './modules/transaction'
import invoice from './modules/invoice'
import customer from './modules/customer'
import prodservice from './modules/prodservice'
import { makeCommonStore } from './commons'

Vue.use(Vuex)

const store = {
  ...makeCommonStore(
    {
      user: null,
      verified: false,
      entity: null,
      bankAccount: null,
      title: 'Taxteam',
      pageTitle: null,
      companyName: 'Taxteam Limited',
      assetRoot: 'https://s3-ap-southeast-2.amazonaws.com/taxteam-assets',
      rules: {
        required: v => !!v || 'Required.',
        email: v => !v || /.+@.+\..+/.test(v) || 'E-mail must be valid',
        phone: v => !v || /^[+-\d]+$/.test(v) || 'Phone number must be valid',
        amount: v => !v || /^\d(?:[\d.]*\d|)$/.test(v) || 'Amount must be valid'
      },
      apps: [
        { name: 'Profile', link: '/profile', icon: 'person', text: '', image: 'Profile.png' },
        { name: 'Entity', link: '/entity', icon: 'list_alt', text: '', image: 'Entity.png' },
        { name: 'Cashbook', link: '/cashbook', icon: 'menu_book', text: '', image: 'Cashbook.png' },
        { name: 'Invoice', link: '/invoice', icon: 'receipt', text: '', image: 'Invoice.png' }
      ],
      banks: [],
      bankAccountTypes: [],
      entityId: null
    },
    ['rules', 'modules']
  ),
  modules: {
    profile,
    entity,
    checklist,
    bankaccount,
    cashbook,
    transaction,
    invoice,
    customer,
    prodservice
  }
}

export default new Vuex.Store(store)
